import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {plainToClass, plainToClassFromExist} from 'class-transformer';
import {environment} from '../../../environments/environment';
import {QueryParamsService} from '../../core/services/query-params.service';
import {QueryParamsApiModel} from '../models/query-params-api.model';
import {ResultListApiModel} from '../models/result-list.api.model';
import {ProjectCollaborationApiModel} from '../models/collaboration/project-collaboration.api-model';

@Injectable({
  providedIn: 'root'
})
export class ProjectCollaborationRestService {
  private readonly resource = '/project_collaborations';

  constructor(
    private readonly http: HttpClient,
    private readonly params: QueryParamsService,
  ) {
  }

  public create(payload: any): Observable<ProjectCollaborationApiModel> {
    return this.http.post<ProjectCollaborationApiModel>(environment.apiUrl + this.resource, payload)
      .pipe(map((result) => plainToClass(ProjectCollaborationApiModel, result)));
  }

  public get(id: string | number): Observable<ProjectCollaborationApiModel> {
    return this.http.get<ProjectCollaborationApiModel>(`${environment.apiUrl}${this.resource}/${id}`)
      .pipe(map((result) => plainToClass(ProjectCollaborationApiModel, result)));
  }

  public put(id: string | number, payload: any): Observable<ProjectCollaborationApiModel> {
    return this.http.put<ProjectCollaborationApiModel>(`${environment.apiUrl}${this.resource}/${id}`, payload)
      .pipe(map((result) => plainToClass(ProjectCollaborationApiModel, result)));
  }

  public changeStatus(id: string | number, status: string): Observable<ProjectCollaborationApiModel> {
    return this.http.post<ProjectCollaborationApiModel>(`${environment.apiUrl}${this.resource}/${id}/status-transition`, {status})
      .pipe(map((result) => plainToClass(ProjectCollaborationApiModel, result)));
  }

  public getCollection(queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel(), options?: {headers?: HttpHeaders}): Observable<ResultListApiModel<ProjectCollaborationApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<ProjectCollaborationApiModel>>(environment.apiUrl + this.resource, {...options, params})
      .pipe(map((result) => plainToClassFromExist(new ResultListApiModel<ProjectCollaborationApiModel>(ProjectCollaborationApiModel), result as object)));
  }

  public getMyCollection(): Observable<ProjectCollaborationApiModel[]> {
    return this.http.get<ProjectCollaborationApiModel[]>(`${environment.apiUrl}${this.resource}/my`)
      .pipe(map((result) => (result || []).map((row) => plainToClass(ProjectCollaborationApiModel, row))));
  }

  public getOwnedCollection(): Observable<ProjectCollaborationApiModel[]> {
    return this.http.get<ProjectCollaborationApiModel[]>(`${environment.apiUrl}${this.resource}/owned`)
      .pipe(map((result) => (result || []).map((row) => plainToClass(ProjectCollaborationApiModel, row))));
  }
}
